import React from 'react';
import { Typography } from '../../../../../../wag-react/components/Typography';
import { Box } from '../../../../../../wag-react/next-components/box';
export const WellnessLabel = ({
  text
}) => <Box bg="#995AA0" borderRadius="12px" left={[0, '16px']} py="4px" px="8px" position="absolute" right={[0, 'unset']} top="-12px" data-sentry-element="Box" data-sentry-component="WellnessLabel" data-sentry-source-file="index.tsx">
    <Typography color="white" fontFamily="muliBold" fontSize="12px" m={0} textAlign="center" textTransform="uppercase" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
      {text}
    </Typography>
  </Box>;